import useContentPhysicalRegistration from "./useContentPhysicalRegistration";
import { UseContentPhysicalRegistrationReturn } from "./useContentPhysicalRegistration";
import { useState ,useEffect} from "react";
import { useFirebase } from "../../../../../../../context/FirebaseContext/FirebaseContext";
import { isProduction } from "../../../../../../../configurations/Axios/Clients";
import useAxios from "../../../../../../../context/AxiosContext/AxiosContext";
import { PhysycalPayment} from "../../../../../../../configurations/Axios/urls";
import { physicalRegistration } from "./useContentPhysicalRegistration";
export interface UsePhysicalRegistrationReturn {
    vouucherdata: any | null; // Puedes reemplazar `any` con una interfaz específica si conoces la estructura del voucher
    voucherstatus: boolean | null;
    openVoucherViewer: boolean;
    handleOpenVoucherPicture: (row: any) => void;
    handleVoucherModalSubmit: (imageFile: File, coment: string, voucher: any) => void;
    setOpenModalViewer: React.Dispatch<React.SetStateAction<boolean>>;
    setvoucherstatus: React.Dispatch<React.SetStateAction<boolean | null>>;
    setvoucherdata: React.Dispatch<React.SetStateAction<any | null>>;
    physicalcontent: UseContentPhysicalRegistrationReturn;
}


const usePhysicalRegistration =({user}:physicalRegistration):UsePhysicalRegistrationReturn=>{
    const physicalcontent = useContentPhysicalRegistration({user});
    const {firebasestorage}= useFirebase();
 
    const {VisitaxPut}=useAxios();
    const [vouucherdata, setvoucherdata] = useState<any>(null);
    const [voucherstatus, setvoucherstatus] = useState<boolean | null>(null);
    const [openVoucherViewer, setOpenModalViewer] = useState(false);
    
    useEffect(() => {
   
        if (vouucherdata) setOpenModalViewer(true);
      }, [vouucherdata]);
    
      const handleOpenVoucherPicture = (row:any) => {
        setvoucherdata(row);
      };
    
      const handleVoucherModalSubmit = (imageFile:any, coment:string, voucher:any) => {
      
        const onUpdateResponse = (response:any) => {
            if(response.status ==200){
                setvoucherstatus(true);
                physicalcontent.makeRequest();
                return;
            }
            setvoucherstatus(false);
        };

    
        const UpdatePicture = (url:string) => {
          const actualdescription = vouucherdata?vouucherdata?.description:""
          const payload = { ...voucher, imageUrl: url, description: actualdescription +"/ "+coment};
          VisitaxPut(PhysycalPayment,payload,onUpdateResponse)
        };
    


        if(voucher){
            let filepath;
            if (voucher?.idTransaction) {
              filepath = !isProduction()
                ? "PhysicalVouchersSandox/" + voucher?.idTransaction
                : "PhysicalVouchers/" + voucher?.idTransaction;
            } else {
              filepath = !isProduction()
                ? "LotClousersSandox/" + voucher?.dateCreate
                : "LotClousers/" + voucher?.dateCreate;
            }
            firebasestorage.uploadFile(imageFile,filepath)
            .then((resp) => UpdatePicture(resp))
            .catch((e) => {
                e;
                setvoucherstatus(false);;
              })
             
        }
       
      };
    return ({
        vouucherdata,
        voucherstatus,
        openVoucherViewer,
        handleOpenVoucherPicture,
        handleVoucherModalSubmit,
        setOpenModalViewer,
        setvoucherstatus,
        setvoucherdata,
        physicalcontent
    })
}
export default usePhysicalRegistration;